// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","rowWarning":"RecurringGoalScheduleGrid_rowWarning__1mXQP","secondaryAssignedToCount":"RecurringGoalScheduleGrid_secondaryAssignedToCount__siy1s"};